import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0fd5576"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "middle" }
const _hoisted_4 = {
  key: 0,
  class: "manga-list"
}
const _hoisted_5 = { class: "touch-dom" }
const _hoisted_6 = {
  key: 1,
  class: "chapter-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "search-input",
        modelValue: $setup.searchText,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchText) = $event)),
        clearable: "",
        onClear: $setup.clear,
        onKeyup: _cache[3] || (_cache[3] = _withKeys(() => {
				$setup.page_change();
			}
				, ["enter"]))
      }, {
        append: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: $setup.searchType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchType) = $event)),
            placeholder: "Select",
            class: "search-select"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _ctx.$t('search.manga'),
                value: "manga"
              }, null, 8 /* PROPS */, ["label"]),
              _createVNode(_component_el_option, {
                label: _ctx.$t('search.chapter'),
                value: "chapter"
              }, null, 8 /* PROPS */, ["label"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])
        ]),
        prepend: _withCtx(() => [
          _createVNode(_component_el_button, {
            icon: $setup.Search,
            onClick: _cache[1] || (_cache[1] = () => {
						$setup.page_change();
					}
						)
          }, null, 8 /* PROPS */, ["icon"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"]),
      ($setup.config.screenType !== 'small')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "search-btn",
            type: "primary",
            onClick: _cache[4] || (_cache[4] = () => {
				$setup.page_change();
			}
				)
          }, {
            default: _withCtx(() => [
              _createTextVNode("全局搜索")
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createCommentVNode(" 加载骨架屏 "),
      ($setup.loading)
        ? (_openBlock(), _createBlock($setup["listSkeleton"], { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ($setup.searchType === 'manga')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['manga-list-box', { block: $setup.config.viewType === 'list' }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (i, k) => {
                        return (_openBlock(), _createBlock($setup["manga"], {
                          key: k,
                          viewType: $setup.config.viewType,
                          mangaInfo: i,
                          onContextmenu: _withModifiers(($event: any) => ($setup.context_menu(i, k)), ["prevent"])
                        }, null, 8 /* PROPS */, ["viewType", "mangaInfo", "onContextmenu"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 2 /* CLASS */)
                  ]),
                  _createCommentVNode(" 分页组件 "),
                  _createVNode($setup["mediaPager"], {
                    ref: "pager",
                    page: $setup.page,
                    count: $setup.count,
                    "page-size-config": $setup.pageSizes,
                    onPageChange: $setup.page_change
                  }, null, 8 /* PROPS */, ["page", "count", "page-size-config"])
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.searchType === 'chapter')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createCommentVNode(" 章节列表 "),
                  _createElementVNode("div", {
                    class: _normalizeClass(['chapter-list-box', { block: $setup.config.viewType === 'list' }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (i, k) => {
                      return (_openBlock(), _createBlock($setup["chapter"], {
                        key: k,
                        "view-type": $setup.config.viewType,
                        chapterInfo: i,
                        onClick: ($event: any) => ($setup.go_browse(i)),
                        onContextmenu: _withModifiers(($event: any) => ($setup.context_menu(i, k)), ["prevent"])
                      }, null, 8 /* PROPS */, ["view-type", "chapterInfo", "onClick", "onContextmenu"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 2 /* CLASS */),
                  _createCommentVNode(" 分页组件 "),
                  _createVNode($setup["mediaPager"], {
                    ref: "pager",
                    page: $setup.page,
                    count: $setup.count,
                    "page-size-config": $setup.pageSizes,
                    onPageChange: $setup.page_change
                  }, null, 8 /* PROPS */, ["page", "count", "page-size-config"])
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
    ])
  ]))
}